module.exports = __webpack_public_path__ + "img/20220131.44641552.png";